import 'swiper/components/navigation/navigation.scss';
import 'swiper/swiper.min.css';

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import UI from '#front-credpago';

import useResizer from '../../../utils/useResizer';
import * as S from './styles';

const Culture = ({ data }) => {
  const isMobile = useResizer();

  const cards = [
    {
      img: data.Telescope.childImageSharp.fluid,
      title: 'Visão',
      description:
        'Ser a verdadeira revolução no mercado imobiliário com excelência no atendimento e na experiência proporcionada ao cliente, destacando-se pela ética, eficiência e respeito, e comprometida com a desburocratização e inovação constante do mercado.',
    },

    {
      img: data.Target.childImageSharp.fluid,
      title: 'Missão',
      description:
        'Através da tecnologia desenvolver soluções para reinventar e desburocratizar o mercado imobiliário no Brasil, proporcionando às imobiliárias, inquilinos e proprietários de imóveis mais facilidade e agilidade nas negociações, assim permitindo que todos os cidadãos tenham acesso à moradia.',
    },

    {
      img: data.Flag.childImageSharp.fluid,
      title: 'Valores',
      description: ['Inovação', 'confiabilidade', 'ética', 'dedicação', 'respeito', 'comprometimento', 'pioneirismo'],
    },
  ];

  if (isMobile) {
    return (
      <S.WrapperCards id="missao-visao-valores">
        <Swiper spaceBetween={1} slidesPerView={1}>
          {cards.map((card) => (
            <SwiperSlide key={card.title}>
              <S.Card>
                <S.WrapperImg>
                  <S.Image fluid={card.img} model={card.title === 'Visão' ? 1 : card.title === 'Missão' ? 2 : 0} />
                </S.WrapperImg>
                <S.WrapperContent>
                  <UI.Title fontWeight="800" level={4} splitLabel={['', card.title]} />

                  {card.title !== 'Valores' ? (
                    <UI.Description color="gray" style={{ textAlign: 'center', marginTop: 20 }}>
                      {card.description}
                    </UI.Description>
                  ) : (
                    card.description.map((item) => (
                      <UI.Description
                        key={item}
                        color="gray"
                        style={{
                          textAlign: 'center',
                          marginTop: 20,
                          textTransform: 'uppercase',
                        }}
                      >
                        {item}
                      </UI.Description>
                    ))
                  )}
                </S.WrapperContent>
              </S.Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </S.WrapperCards>
    );
  }

  return (
    <S.FullWidthWrapper id="missao-visao-valores">
      <S.Container>
        {cards.map((card) => (
          <S.Card key={card.title}>
            <S.WrapperImg>
              <S.Image fluid={card.img} model={card.title === 'Visão' ? 1 : card.title === 'Missão' ? 2 : 0} />
            </S.WrapperImg>

            <S.WrapperContent>
              <UI.Title fontWeight="800" level={3} splitLabel={['', card.title]} />

              {card.title !== 'Valores' ? (
                <UI.Description color="gray" style={{ textAlign: 'center', marginTop: 20 }}>
                  {card.description}
                </UI.Description>
              ) : (
                card.description.map((item) => (
                  <UI.Description
                    key={item}
                    color="gray"
                    style={{
                      textAlign: 'center',
                      marginTop: 20,
                      textTransform: 'uppercase',
                    }}
                  >
                    {item}
                  </UI.Description>
                ))
              )}
            </S.WrapperContent>
          </S.Card>
        ))}
      </S.Container>
    </S.FullWidthWrapper>
  );
};

export default Culture;
